import { render, h } from 'preact';
import PbeakkCalculator from './PbeakkCalculator';

var calculators = document.getElementsByClassName('js-premium-calc-react');
Array.prototype.forEach.call(calculators, function(calculator) {

	const calculatorType = calculator.dataset.calculatorType;
	const calculatorTypeUid = calculator.dataset.calculatorTypeUid;
	const steps = calculator.dataset.calculatorSteps;
	const minAge = calculator.dataset.calculatorMinAge;
	const maxAge = calculator.dataset.calculatorMaxAge;
	const maxRealAge = calculator.dataset.calculatorMaxRealAge;
	const data = JSON.parse(calculator.dataset.calculatorValues);

	render(<PbeakkCalculator
		calculatorType={calculatorType}
		calculatorTypeUid={calculatorTypeUid}
		steps={steps}
		minAge={minAge}
		maxAge={maxAge}
		maxRealAge={maxRealAge}
		data={data}
	/>, calculator);
});
